import { c as _c } from "react/compiler-runtime";
import { atom, useAtom } from "jotai";
const loginModalAtom = atom(false);
export function useLoginModal() {
  const $ = _c(8);
  const [open, setOpen] = useAtom(loginModalAtom);
  let t0;
  let t1;
  if ($[0] !== setOpen) {
    t0 = () => setOpen(true);
    t1 = () => setOpen(false);
    $[0] = setOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== open || $[4] !== setOpen || $[5] !== t0 || $[6] !== t1) {
    t2 = {
      open,
      onOpen: t0,
      onClose: t1,
      onOpenChange: setOpen
    };
    $[3] = open;
    $[4] = setOpen;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}